import _extends from "@babel/runtime/helpers/extends";
import { DomainSearchSuiteModule } from '@wix/domains-search-suite';
import React from 'react';
import { Recommendations, RecommendationsError } from '../../Components/Recommendations';
import { DomainSearchGateModule } from '../../module/domainSearchGate.module';
import { useResultsPageContext } from './ResultsPageContext';
export const ResultsRecommendations = _ref => {
  let {
    showHeroCard = true,
    className,
    getItButtonOverride,
    insightIntent,
    hideAiInsights = false,
    emptyState,
    ...recommendationsProps
  } = _ref;
  const {
    recommendations,
    isLoading,
    hasMore,
    error,
    onRetry,
    fetchNextPage,
    isFetchingNextPage,
    resolveActionForSuggestion,
    useCompactRecommendationsLayout,
    banner,
    deviceType,
    productType,
    isPricingLoading
  } = useResultsPageContext();
  if (error) {
    if (error === 'NoRecommendations' && emptyState !== undefined) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, emptyState);
    }
    return /*#__PURE__*/React.createElement(RecommendationsError, {
      error: error,
      onRetry: onRetry,
      type: "anonymous",
      gridColumn: "1 / -1"
    });
  }
  return /*#__PURE__*/React.createElement(Recommendations, _extends({
    recommendations: recommendations,
    isLoading: isLoading,
    hasMore: hasMore,
    className: className,
    showHeroCard: showHeroCard,
    useCompactRecommendationsLayout: useCompactRecommendationsLayout,
    getItButtonOverride: getItButtonOverride,
    isPricingLoading: isPricingLoading,
    banner: banner
  }, recommendationsProps, {
    onAiInsightsClick: hideAiInsights ? undefined : domain => {
      var _recommendations$posi;
      const position = recommendations.findIndex(r => r.domain === domain);
      DomainSearchSuiteModule.internals.bi.onCTAClick == null || DomainSearchSuiteModule.internals.bi.onCTAClick({
        ctaClick: 'ai_insights_button',
        domain,
        position,
        type: (_recommendations$posi = recommendations[position]) == null ? void 0 : _recommendations$posi.label,
        deviceType: deviceType === 'Smartphone' ? 'mobile' : 'desktop'
      });
      DomainSearchGateModule.internals.insightsModalsController.aiInsights.show({
        domain,
        ...(insightIntent && {
          intent: {
            intent: insightIntent
          }
        }),
        ...(productType && {
          productType
        }),
        onGetIt: clickedDomain => {
          const index = recommendations.findIndex(r => r.domain === clickedDomain);
          if (index === -1) {
            return;
          }
          const type = recommendations[index].label;
          DomainSearchSuiteModule.internals.bi.onGetItClick == null || DomainSearchSuiteModule.internals.bi.onGetItClick({
            origin: 'ai_insights_modal',
            domain: clickedDomain,
            type,
            position: index
          });
          resolveActionForSuggestion(clickedDomain);
        }
      });
    },
    fetchNextPage: () => {
      DomainSearchSuiteModule.internals.bi.onCTAClick == null || DomainSearchSuiteModule.internals.bi.onCTAClick({
        ctaClick: 'show_more_results'
      });
      fetchNextPage();
    },
    isFetchingNextPage: isFetchingNextPage,
    gridArea: "content"
  }));
};
//# sourceMappingURL=ResultsRecommendations.js.map